import React, { useCallback, useMemo, useState } from "react";
import { Grid } from "semantic-ui-react";
import MappingRequest from "./MappingRequest";
import MappingReplies from "./MappingReplies";
import { SupplierClientRequestTab } from "../../config/constants";

const MappingInteractionTab = () => {
  const [activeTab, setActiveTab] = useState(1);
  const [currentAvailableMappingRequest, setCurrentAvailableMappingRequest] =
    useState<any>(0);
  const [currentAvailableMappingReply, setCurrentAvailableMappingReply] =
    useState<any>(0);

  const selectActiveTab = (tabId: number) => {
    setActiveTab(tabId);
  };

  const MappingInteraction = useMemo(() => {
    switch (activeTab) {
      case 1:
        return <MappingRequest currentAvailableMappingRequest={(e: any) => setCurrentAvailableMappingRequest(e)} />;
      case 2:
        return <MappingReplies currentAvailableMappingReply={(e: any) => setCurrentAvailableMappingReply(e)} />;
    }
  }, [activeTab]);

  return (
    <div className="mt-2">
      <Grid className="ml-0 mr-0">
        {SupplierClientRequestTab.map((tab, index) => {
          const newMessageCount = index === 0 ? currentAvailableMappingRequest.length || 0 : currentAvailableMappingReply.length || 0;
          const messageCountColor = index === 0 ? "supplier-request-content-supplier-color" : "supplier-request-content-supplier-color-2";
          return (<Grid.Column
            key={tab.id}
            computer={3}
            tablet={8}
            mobile={8}
            onClick={() => selectActiveTab(tab.id)}
            className={
              activeTab === tab.id
                ? "supplier-selected-tab"
                : "supplier-unselect-tab"
            }
          >
            <div>
              <Grid>
                <Grid.Column
                  computer={16}
                  tablet={8}
                  mobile={8}
                  className="pb-0 mb-1"
                >
                  <div className="supplier-request-title-main">
                    <p className="supplier-request-title">{tab.title}</p>
                    <p className={`${messageCountColor} supplier-request-content-supplier`}>{`${newMessageCount} New`}</p>
                  </div>
                </Grid.Column>
              </Grid>
              <Grid className="supplier-sub-content-main">
                <Grid.Column
                  computer={16}
                  tablet={16}
                  mobile={16}
                  className="pt-0 mt-0"
                >
                  <p className="supplier-sub-text">{tab.subtitle}</p>
                </Grid.Column>
              </Grid>
            </div>
          </Grid.Column>
          )
        })}
      </Grid>
      {MappingInteraction}
    </div>
  );
};

export default MappingInteractionTab;
